'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var splice = [].splice;

module.exports = function (request, stores, resourceUtils) {
  var Resource;
  return Resource = function () {
    function Resource(url) {
      var returnErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _classCallCheck(this, Resource);

      this.returnErrors = returnErrors;
      this.resourceUrl = url;
      request.Request.prototype.csrf = function (token) {
        if (!token) {
          token = window.csrf;
        }
        this.set('X-CSRF-Token', token);
        return this;
      };
    }

    _createClass(Resource, [{
      key: 'get',
      value: function get() {
        var _ref,
            _ref2,
            _splice$call,
            _splice$call2,
            _this = this;

        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        var cback, ref, ref1, url;
        ref = params, (_ref = ref, _ref2 = _toArray(_ref), params = _ref2.slice(0), _ref), (_splice$call = splice.call(params, -1), _splice$call2 = _slicedToArray(_splice$call, 1), cback = _splice$call2[0], _splice$call);
        if (typeof cback !== 'function') {
          throw new Error('callback not set');
        }
        url = this.resourceUrl + (((ref1 = params[0]) != null ? ref1.id : void 0) ? "/" + params[0].id : "");
        return request.get(url, params[0], function (err, res) {
          return _this.createResponse(err, res, params, cback, 'get');
        });
      }
    }, {
      key: 'post',
      value: function post() {
        var _ref3,
            _ref4,
            _splice$call3,
            _splice$call4,
            _this2 = this;

        for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          params[_key2] = arguments[_key2];
        }

        var cback, ref, ref1, url;
        ref = params, (_ref3 = ref, _ref4 = _toArray(_ref3), params = _ref4.slice(0), _ref3), (_splice$call3 = splice.call(params, -1), _splice$call4 = _slicedToArray(_splice$call3, 1), cback = _splice$call4[0], _splice$call3);
        if (typeof cback !== 'function') {
          throw new Error('callback not set');
        }
        url = this.resourceUrl + (((ref1 = params[0]) != null ? ref1.id : void 0) ? "/" + params[0].id : "");
        return request.post(url).send(params[0]).csrf().end(function (err, res) {
          return _this2.createResponse(err, res, params, cback, 'post');
        });
      }
    }, {
      key: 'save',
      value: function save() {
        var _ref5,
            _ref6,
            _splice$call5,
            _splice$call6,
            _this3 = this;

        for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          params[_key3] = arguments[_key3];
        }

        var cback, ref, ref1, ref2, url;
        ref = params, (_ref5 = ref, _ref6 = _toArray(_ref5), params = _ref6.slice(0), _ref5), (_splice$call5 = splice.call(params, -1), _splice$call6 = _slicedToArray(_splice$call5, 1), cback = _splice$call6[0], _splice$call5);
        if (typeof cback !== 'function') {
          throw new Error('callback not set');
        }
        url = this.resourceUrl + (((ref1 = params[0]) != null ? ref1.id : void 0) ? "/" + params[0].id : "");
        if ((ref2 = params[0]) != null ? ref2.id : void 0) {
          return request.put(url).send(params[0]).csrf().end(function (err, res) {
            return _this3.createResponse(err, res, params, cback, 'save');
          });
        } else {
          return request.post(url).send(params[0]).csrf().end(function (err, res) {
            return _this3.createResponse(err, res, params, cback, 'save');
          });
        }
      }
    }, {
      key: 'remove',
      value: function remove() {
        var _ref7,
            _ref8,
            _splice$call7,
            _splice$call8,
            _this4 = this;

        for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          params[_key4] = arguments[_key4];
        }

        var cback, ref, ref1, url;
        ref = params, (_ref7 = ref, _ref8 = _toArray(_ref7), params = _ref8.slice(0), _ref7), (_splice$call7 = splice.call(params, -1), _splice$call8 = _slicedToArray(_splice$call7, 1), cback = _splice$call8[0], _splice$call7);
        if (typeof cback !== 'function') {
          throw new Error('callback not set');
        }
        url = this.resourceUrl + (((ref1 = params[0]) != null ? ref1.id : void 0) ? "/" + params[0].id : "");
        return request.del(url).send(params[0]).csrf().end(function (err, res) {
          return _this4.createResponse(err, res, params, cback, 'remove');
        });
      }
    }, {
      key: 'createResponse',
      value: function createResponse(err, res, params, cback, method) {
        var data, ref;
        data = resourceUtils.responseConvert(res != null ? (ref = res.body) != null ? ref.data : void 0 : void 0);
        if (!this.returnErrors && cback != null) {
          cback(data);
        }
        if (err) {
          err = res.body;
        }
        if (this.returnErrors && cback != null) {
          return cback(data, err);
        }
      }
    }]);

    return Resource;
  }();
};